export default {
	design: {
		type: 'string',
		default: 'basic',
	},
	color: {
		type: 'string',
		default: '',
	},
	hrMarginTop: {
		type: 'number',
		default: '',
	},
	hrMarginBottom: {
		type: 'number',
		default: '',
	},
	height: {
		default: '',
		type: 'number',
	},
	width: {
		default: '',
		type: 'number',
	},
	alignment: {
		type: 'string',
		default: 'center',
	},
}
